"use strict";
var AsapScheduler_1 = require('./AsapScheduler');
exports.asap = new AsapScheduler_1.AsapScheduler();
//# sourceMappingURL=asap.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/scheduler/asap.js
 ** module id = 607
 ** module chunks = 3
 **/